import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { reviews } from "@/mocks/highlights";

type Review = (typeof reviews)[number];

function ReviewItem({ review }: { review: Review }) {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(review.likes);

  const toggle = () =>
    setLiked((prev) => {
      setCount((c) => (prev ? c - 1 : c + 1));
      return !prev;
    });

  return (
    <article className="reveal rounded-2xl border border-background-200 bg-background-50 p-5 flex gap-4">
      <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
        <img
          src={review.avatar}
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span className="font-label font-medium text-sm text-foreground-900">{review.user}</span>
          <span className="text-xs text-foreground-400">{review.time}</span>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{review.text}</p>
        <button
          type="button"
          onClick={toggle}
          aria-pressed={liked}
          className={`mt-3 inline-flex items-center gap-1.5 text-xs font-label transition-colors cursor-pointer ${
            liked ? "text-primary-600" : "text-foreground-500 hover:text-primary-600"
          }`}
        >
          <i className={liked ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
          {count}
        </button>
      </div>
    </article>
  );
}

export default function ReviewsSection() {
  return (
    <section id="reviews" className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="观众热评"
          title="追剧的人，都在聊些什么"
          desc="看看其他观众的反馈：有人冲着演员表来，有人专门翻花絮，也有人喜欢绯闻区把真假分开的做法。"
          accent="secondary"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {reviews.map((review) => (
            <ReviewItem key={review.id} review={review} />
          ))}
        </div>
      </div>
    </section>
  );
}